import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClinicStore } from '@core/stores/clinic.store';

@Injectable()
export class ClinicIdInterceptor implements HttpInterceptor {
  constructor(private readonly clinicStore: ClinicStore) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const body: any = req.body;
    let clinicId: any = body?.where?.clinicId ?? body?.clinicId;
    if (clinicId == null) {
      // fallback: clinicId з URL-path /clinic/{id}/... або /transaction/{id}/...
      const m = req.url.match(/\/(?:clinic|transaction)\/(\d+)(?:\/|$)/);
      if (m) clinicId = m[1];
    }
    if (clinicId == null) {
      // фінальний fallback: активна клініка з глобального стора
      clinicId = this.clinicStore.get()?.id;
    }
    if (clinicId != null && clinicId !== '' && !req.params.has('clinicId')) {
      req = req.clone({ setParams: { clinicId: String(clinicId) } });
    }
    return next.handle(req);
  }
}
